import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { Theme } from 'features/ui/types'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'

/* Import from @netbasequid/theme will somehow causes jest fail (SyntaxError: Cannot use import statement outside a module)
By default, if Jest sees a Babel config, it will use that to transform your files, ignoring "node_modules".
Here's what you can do:
• If you are trying to use ECMAScript Modules, see https://jestjs.io/docs/en/ecmascript-modules for how to enable it.
• To have some of your "node_modules" files transformed, you can specify a custom "transformIgnorePatterns" in your config.
• If you need a custom transformation specify a "transform" option in your config.
• If you simply want to mock your non-JS modules (e.g. binary assets) you can stub them out with the "moduleNameMapper" config option.
You'll find more details and examples of these config options in the docs:
https://jestjs.io/docs/en/configuration.html
*/

interface StyledLinkButtonProps {
  displayTheme?: Theme
}

const StyledLinkButton = styled.button<StyledLinkButtonProps>`
  color: ${({ displayTheme }) => sys[displayTheme].interaction.primary.default};
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
  font-size: inherit;
  &:hover {
    cursor: pointer;
  }
`

const LinkButton = forwardRef((props: any, ref) => {
  const displayTheme = useDisplayTheme()
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <StyledLinkButton displayTheme={displayTheme} ref={ref} {...props} />
})

export default LinkButton
